/*
 * Copyright (c) 2020.
 * Simon
 */

import React, {Component} from 'react';
import {i18n} from "../../language/i18n";
import HearFacebookButton from "./HearFacebookButton";
import {Input} from "reactstrap";

class HearFacebookButtons extends Component {

    constructor(props) {
        super(props);
        const {buttonsData, replyData} = this.props;

        this.buttons = buttonsData;
        this.buttonCount = 3;

        let text = replyData === undefined ? "" : replyData.text;
        text = text === null ? "" : text;

        this.state = {
            buttonsText: text,
            replyData: replyData,
            buttonsTextValid: false,
            buttonsTextInvalid: false,
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let replyData = nextProps.replyData;
        let text = replyData === undefined ? "" : replyData.text;
        text = text === null ? "" : text;

        this.setState({
            buttonsText: text,
        });
    }

    handleTextChange = (event) => {
        this.setState({buttonsText: event.target.value}, this.updateButtonsText);
    };

    updateButtonsText() {
        const {hearReplies, replyIndex} = this.props;
        hearReplies.updateReply(replyIndex, "text", this.state.buttonsText);
    }

    updateButtons(index, buttonData) {
        const {buttonsHolder, replyIndex} = this.props;

        if (this.buttons === undefined) {
            this.buttons = [];
        }

        if (!this.buttons[index]) {
            this.buttons[index] = {};
        }

        this.buttons[index] = buttonData;

        let buttonsData = this.buttons.filter(function (el) {
            return el != null;
        });

        buttonsHolder.updateReply(replyIndex, 'buttons', buttonsData);
    }

    deleteButtons(index) {
        const {buttonsHolder, replyIndex} = this.props;

        if (this.buttons === undefined || this.buttons[index] === undefined) {
            return;
        }

        delete this.buttons[index];

        let buttonsData = this.buttons.filter(function (el) {
            return el != null;
        });

        buttonsHolder.updateReply(replyIndex, 'buttons', buttonsData);
    }

    createButtons = () => {
        const {buttonsData} = this.props;

        let buttons = [];

        for (let i = 0; i < this.buttonCount; i++) {

            let buttonData = null;
            if (buttonsData === undefined || buttonsData[i] === undefined) {
                buttonData = undefined;
            } else {
                buttonData = buttonsData[i];
            }

            buttons.push(<HearFacebookButton
                key={i}
                fanpageId={this.props.fanpageId}
                hearId={this.props.hearId}
                replyIndex={this.props.replyIndex}
                buttonIndex={i}
                hearButtons={this}
                buttonData={buttonData}
            />);
            if (i === this.buttonCount - 1) break;
            buttons.push("--")
        }
        return buttons;
    };

    render() {
        return (
            <div className="hear-element hear-facebook-buttons">
                {
                    this.props.genericButton === true ? "" : <Input
                        placeholder={i18n.t("Text of buttons")}
                        id={'buttons_text_' + this.props.replyIndex}
                        value={this.state.buttonsText}
                        onChange={this.handleTextChange}
                        invalid={this.state.buttonsTextInvalid}
                        valid={this.state.buttonsTextValid}
                    />
                }

                <small className="form-text text-muted">
                    <b className="text-danger">{i18n.t("Required.")}</b>&nbsp;
                    {i18n.t("Minimum 1 button.")}
                </small>

                {this.createButtons()}
            </div>
        );
    }
}


export default HearFacebookButtons;

